import React from "react";
import "./Hero.css";
import Orb from "../effects/Orb";

const STATS = [
  { value: "1500+", label: "Placements / Year" },
  { value: "98%",  label: "Satisfaction Rate" },
  { value: "50+",  label: "Partner Companies" },
  { value: "10+",  label: "Years of Expertise" },
];

const Hero = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="hero" id="hero">
      <div className="hero__liquid-rings" aria-hidden="true">
        <div className="hero__liquid-ring hero__liquid-ring--outer" />
        <div className="hero__liquid-ring hero__liquid-ring--inner" />
      </div>

      {/* Interactive WebGL Orb background */}
      <div className="hero__orb-wrapper">
        <Orb
          hue={0}
          hoverIntensity={0.5}
          rotateOnHover={true}
          backgroundColor="#060612"
        />
      </div>

      {/* Decorative grid */}
      <div className="hero__grid" />

      <div className="hero__inner">
        <div className="hero__pill glass">
          <span className="hero__dot" />
          Trusted by 200+ Professionals Annually
        </div>

        <h1 className="hero__h1">
          <span>Shaping Careers,</span>
          <span className="grad-text">Building Futures</span>
        </h1>

        <p className="hero__sub">
          USA's leading IT &amp; non-IT staffing consultancy. We craft your
          personal brand, sharpen your skills, and connect you to the opportunity
          you deserve — from first resume to final offer.
        </p>

        <div className="hero__actions">
          <button className="hero__btn-primary" onClick={() => scrollTo("contact")}>
            Start Your Journey →
          </button>
          <button className="hero__btn-outline glass glass-hover" onClick={() => scrollTo("services")}>
            Explore Services
          </button>
        </div>

        <div className="hero__stats-wrap">
          <div className="hero__stats glass">
            {STATS.map((s) => (
              <div className="hero__stat" key={s.label}>
                <span className="hero__stat-n grad-text">{s.value}</span>
                <span className="hero__stat-l">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="hero__scroll-cue" aria-hidden="true">
        <span>Scroll to explore</span>
        <i />
      </div>

      {/* Bottom fade */}
      <div className="hero__fade" />
    </section>
  );
};

export default Hero;
